export const PIX_KEY = 'pix-key'
